import { Component } from 'react'
import styles from '~/styles/ordersPage.awaitOrderItems.module.css'
import types from '~/types/ordersPage.ts'

export default class AwaitOrderItems extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
	}

	render() {
		const isClicked = !!(this.props.clickedOrderId) 
		const isInList = (this.props.clickedOrderId === this.props.orderId)
		const isLoaded = (this.props.currentOrderId === this.props.orderId)
		const isLoading = this.props.loading === this.props.orderId
		if ((isClicked && isInList && !isLoaded) || isLoading) {
			let content: Array<JSX.Element> | JSX.Element | string = []
			content.push(this._getLoading(0))
			content.push(this._getLoading(1))
			content.push(this._getLoading(2))
			return (
				<div>
					<div
						className={styles.waiting}
					>
						{content}
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	private _getLoading(i): JSX.Element | null {
		let divs: Array<JSX.Element> = []
		for (let j = 0; j < 9; j++) {
			divs.push(( <div key={j}/> ))
		}
		return (
			<div
				key={i}
				className={styles.loadingGrid}
			>
				{divs}
			</div>
		)
	}
}